// Modules
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { IntlProvider } from "react-intl";
import * as actionTypes from "../../config/store/actions"; // Adjust the import path as necessary
import { loadLocaleData, getLanguagePreference } from "./utils/locales";

const Locales = ({ children }) => {
    const dispatch = useDispatch();
    const customization = useSelector(state => state.customization);
    const [messages, setMessages] = useState();

    useEffect(() => {
        let languagePreference = undefined;

        if (!customization.locale) {
            languagePreference = getLanguagePreference();
            dispatch({ type: actionTypes.THEME_LOCALE, locale: languagePreference });
        }

        const localeToLoad = customization.locale || languagePreference;

        loadLocaleData(localeToLoad).then(d => {
            setMessages(d.default);
        });
    }, [customization.locale, dispatch]);

    return (
        <>
            {messages && (
                <IntlProvider locale={customization.locale} defaultLocale="de" messages={messages}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

export default Locales;
